// extracted by mini-css-extract-plugin
module.exports = {"container":"fu-z","links":"gu-z"};